import SearchProducts from "./SearchProducts"

export default SearchProducts
